var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7369_5752",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.106 0H0V35.107H35.106V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7369_5752)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.1 27.9C35.0995 29.8123 34.3396 31.6461 32.9874 32.9984C31.6352 34.3506 29.8013 35.1105 27.889 35.111H7.21C5.2977 35.1107 3.46381 34.3509 2.1117 32.9986C0.759591 31.6463 -1.8388e-08 29.8123 0 27.9V7.212C-7.35353e-08 5.29961 0.759559 3.46551 2.11164 2.11305C3.46372 0.760598 5.29761 0.000530337 7.21 0H27.894C29.8065 0.000530271 31.6405 0.760566 32.9927 2.11299C34.345 3.46542 35.1047 5.29951 35.105 7.212V27.9H35.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4377 10.9078C30.1265 9.76266 29.213 8.86272 28.0506 8.55617C25.9436 8 17.5 8 17.5 8C17.5 8 9.05639 8 6.9516 8.55617C5.78918 8.86272 4.8757 9.76266 4.56454 10.9078C4 12.9814 4 17.3103 4 17.3103C4 17.3103 4 21.6393 4.56454 23.7128C4.8757 24.858 5.78918 25.758 6.9516 26.0645C9.05639 26.6207 17.5 26.6207 17.5 26.6207C17.5 26.6207 25.9436 26.6207 28.0484 26.0645C29.2108 25.758 30.1243 24.858 30.4355 23.7128C31 21.6393 31 17.3103 31 17.3103C31 17.3103 31 12.9814 30.4355 10.9078H30.4377Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7988 21.2998V13.3208L21.8155 17.3103L14.7988 21.2998Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.e49ad38328219ea0b6b814b1bd323e78.svg";
export { ForwardRef as ReactComponent };